<template>
	<div>
		<ValidationObserver ref="verifyMfa" v-slot="{ invalid, validated, passes }">
			<v-form>
				<ValidationProvider v-slot="{ errors }" name="mfaCode" rules="required|min:6">
					<span class="label">{{codeText}}</span>
					<v-text-field
						v-model.trim="mfaCode"
						:error-messages="errors"
						placeholder="Enter Code"
						class="remove-padding"
						autofocus
						filled
						@keydown.enter="submit"
					/>
				</ValidationProvider>
				<div v-if="err.length" class="error-callback">
					<ul>
						<li v-for="error in err" :key="error">{{ error }}</li>
					</ul>
				</div>
				<v-layout justify-space-between align-content-center>
					<v-row>
						<v-col cols="12" sm="6" class="top-row-align">
							<span class="resend-text">Didn't get a code? <a href @click.prevent="resendCode">Resend</a></span>
							<v-spacer/>
						</v-col>
						<v-col cols="12" sm="6" class="bottom-row-align forgot-pw">
							<v-btn
								class="white--text override-bg"
								color="third"
								:loading="loading"
								:disabled="invalid || !validated || loading"
								@click.prevent="passes(submit($event))"
							>Login</v-btn>
							
						</v-col>
					</v-row>
				</v-layout>
			</v-form>
		</ValidationObserver>
	</div>
</template>

<script>
	import Auth from "@aws-amplify/auth";
	import Cookies from 'js-cookie';

	export default {
    name: 'VerifyMFA',
		props: {
			user: {
				type: Object,
				default: () => ({})
			},
			credentials: {
				type: Object,
				required: true
			},
			response: { type: Function, default: null }
		},
		data: () => ({
			loading: false,
			err: '',
			e1: true,
			password: "",
			email: "",
      mfaCode: ""
		}),
    computed: {
      codeText() {
        return 'Please enter the code you received via text message'
      }
    },

		watch: {
			mfaCode: function() {
				this.clearErrors();
			}
		},
    
		methods: {
			checkForQueryString () {
				const urlParams = new URLSearchParams(this.$searchParams.location.search);
				const query = urlParams.get('orgID');

				return query;
			},
			submit(e) {
				// eslint-disable-next-line no-console
				console.log('submit ', e)
				e.preventDefault()
				this.loading = true;
				const { user, mfaCode } = this;
				// eslint-disable-next-line no-console
				console.log('code here', mfaCode)
				Auth.confirmSignIn(user, mfaCode)
				.then(user => {
					// eslint-disable-next-line no-console
					console.log('login okay...', user);

					Auth.currentSession().then(async session => {
						// eslint-disable-next-line no-console
						console.log('session info', session)
						const token = session.refreshToken.token
						const domain = process.env.VUE_APP_cookie_domain || 'cameramatics.com'
						const name = process.env.VUE_APP_cookie_name || 'CameraMaticsToken'
						const accessToken = session.accessToken.jwtToken
						// eslint-disable-next-line no-console
						console.log(domain)
						// eslint-disable-next-line no-console
						console.log(name)

						Cookies.set(name, token, { expires: 7, domain: domain })
						Cookies.set('accessToken', accessToken, { expires: 7, domain: domain })
						
						this.response(user, this.checkForQueryString())
						
					}).catch(err => {
						// eslint-disable-next-line no-console
						console.log('could not set cookies...', err)
						this.response(user, this.checkForQueryString())
					})
				})
				.catch(err => {
					// eslint-disable-next-line no-console
					console.log('login failed...', err);
					this.loading = false;
					this.err = ['Invalid code - please try again.'];
				});
			},
			resendCode() {
				// eslint-disable-next-line no-console
				console.log('resend code')
				Auth.signIn(this.credentials.email, this.credentials.password)
					.then(user => {
						// eslint-disable-next-line no-console
						console.log('login okay...', user);

						Auth.currentSession().then(async session => {
							// eslint-disable-next-line no-console
							console.log('retry login', session)
						}).catch(err => {
							// eslint-disable-next-line no-console
							console.log('could not set cookies...', err)
							this.response(user, this.checkForQueryString())
						})
					})
					.catch(err => {
						// eslint-disable-next-line no-console
						console.log('login failed...', err);
						this.loading = false;
						this.err = [err.message];
					});
			},
			clearErrors() {
				if (this.err.length > 0) {
					this.err = [];
				}
			}
		}
	};
</script>

<style lang="scss" >
		.top-row-align {
			text-align: left;
		}

		.bottom-row-align {
			text-align: right;
		}

		.label {
			display: block;
			text-align: left;
			color: white;
			font-size: 1rem;
			font-weight: 400;
			padding-bottom: 0.5em;
		}

		.forgot-pw {
			a {
				color: white !important;
			}
		}

		.resend-text {
			color: white;
			a {
				color: lightblue !important;
			}
		}

	@media only screen and (max-width: 599px) {
		.top-row-align {
			text-align: center;
		}

		.bottom-row-align {
			text-align: center;
		}
	}


	.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn-outlined) {
		color: grey !important;
		background-color: white !important;
	}
	.remove-padding {
		margin-top: 0 !important;
		padding-top: 0 !important;
	}
	.theme--light.v-counter {
    color: white !important;
}
</style>
